import React from "react";
function RoamingHomeBannerShimmer(){
    const styles = {
        container:{
            height: '210px'
        }
    }
    return(
    <div className="shimmer-effect shimmerBG mb-4" style={styles.container}> </div>
    )
}

export default RoamingHomeBannerShimmer;